import WaterMarkPlugin from './watermark'
export default WaterMarkPlugin
